<header>
  <app-aon-skip-links></app-aon-skip-links>
</header>
@if (isInsideAndroidApp) {
<hr class="mobile-app-separator" aria-hidden="true">
}
<app-toasts-container class="toast-container-fluid" aria-live="polite" aria-atomic="true"></app-toasts-container>
@if (showHeaderAndFooter) {
<div id="app-header-sleeve-print" class="app-header-sleeve {{siteTheme}}"
  [ngClass]="[siteType === 'OLB' ? (darkModeEnabled ? 'dark-mode' : 'light-mode') : 'dark-mode', clientBrandingModeActive ? 'client-branding-active' : '', enableHighContrastMode ? 'high-contrast-enabled' : '', helperService?.isSelfServiceSite ? 'self-service' : '']">
  @if (showDelegateBar) {
  <div class="delegate-sleeve">
    <app-masthead-delegate-bar [delegateEmployees]="delegateEmployees"></app-masthead-delegate-bar>
  </div>
  }
  @if (isSelfServiceSite) {
  <app-self-service-masthead></app-self-service-masthead>
  }
  @else if (showDelegateMastHead) {
  <app-masthead-delegate></app-masthead-delegate>
  }
  @else {
  <app-masthead></app-masthead>
  }
</div>
}
<app-idle-timeout></app-idle-timeout>
<app-external-redirect-action-popup></app-external-redirect-action-popup>
<div role="main" id="app-modal-anchor" class="main app-content-sleeve {{siteTheme}}"
  [ngClass]="[siteType === 'OLB' ? (darkModeEnabled ? 'dark-mode' : 'light-mode') : 'dark-mode', clientBrandingModeActive ? 'client-branding-active' : '',skinnyFooterActive || showLightFooter()? 'skinny-footer-active' : '', enableHighContrastMode ? 'high-contrast-enabled' : '', helperService.concealTheSensitiveData ? 'sensitive-data-control-active' : '', helperService?.isSelfServiceSite ? 'self-service' : '' ]"
  T3ModalAccess (click)="elementClicked($event)">
  <aon-spin [noDarkSpin]="true"></aon-spin>
  <router-outlet id="main-app-content"></router-outlet>
</div>
@if (showNicChat() && !uiConfig.uiConfiguration.disableWebChat){
<div class="chat-available-div">
  <app-nic-chat></app-nic-chat>
</div>
}
@if (showHeaderAndFooter) {
<div class="app-footer-sleeve {{siteTheme}}"
  [ngClass]="[siteType === 'OLB' ? (darkModeEnabled ? 'dark-mode' : 'light-mode') : 'dark-mode', clientBrandingModeActive ? 'client-branding-active' : '', enableHighContrastMode ? 'high-contrast-enabled' : '', helperService?.isSelfServiceSite ? 'self-service' : '']">
  @if (!isCategorizationEnabled) {
  <app-footer [FooterStyleSwitch]="FooterStyleSwitch"></app-footer>
  }
  @if (isCategorizationEnabled) {
  <app-footer-v2 [FooterStyleSwitch]="FooterStyleSwitch"></app-footer-v2>
  }
</div>
}
<ngx-ui-loader></ngx-ui-loader>